import { AxiosError } from "axios";
import ErrorHelper from "helpers/ErrorHelper";
import { CurrentUserAction } from "providers/currentUserReducer";
import { AuthService } from "./auth";

export async function logOutUserIfTokenInvalid(
	error: AxiosError,
	dispatch: React.Dispatch<{ type: CurrentUserAction }> | null
): Promise<any> {
	const originalRequest = error.config;

	if (originalRequest == null) return Promise.reject(error);

	const noTokenProvided = ErrorHelper.isNoTokenProvidedError(error);
	if (ErrorHelper.isExpiredTokenError(error) || noTokenProvided) {
		const authService = AuthService.getInstance();
		const showLogoutMessage = !noTokenProvided;
		await authService.logout(dispatch, showLogoutMessage);
		return Promise.reject(error);
	}

	return Promise.reject(error);
}
